import React from "react";
import {
  injectIntl,
  MessageDescriptor,
  WrappedComponentProps,
} from "react-intl";
import TailwindTranslatedText, {
  TailwindTranslatedTextValues,
} from "library/components/_tailwind/translated-text";
import TailwindFlex from "library/components/_tailwind/flex";
import TailwindPill from "library/components/_tailwind/pill";

type Props = {
  descriptor: MessageDescriptor;
  values?: TailwindTranslatedTextValues;
  pillContent?: JSX.Element;
  isActive: boolean;
} & WrappedComponentProps;

const BroadcastChatTabLabel: React.ComponentType<Props> = ({
  descriptor,
  values,
  pillContent,
  intl,
}) => {
  const fullText = intl.formatMessage(descriptor, values as any);
  return (
    <TailwindFlex
      width={"w-full"}
      justifyContent={"justify-center"}
      alignItems={"items-center"}
      htmlElementProps={{ title: fullText }}>
      <TailwindTranslatedText
        fontWeight={"font-bold"}
        descriptor={descriptor}
        values={values}
      />
      {pillContent && (
        <TailwindPill
          margin={["ml-1"]}
          padding={["px-3", "py-1"]}
          backgroundColor={"bg-pink-700"}
          textColor={"text-white"}
          textProps={{
            fontWeight: "font-bold",
          }}>
          {pillContent}
        </TailwindPill>
      )}
    </TailwindFlex>
  );
};

export default injectIntl(BroadcastChatTabLabel);
